import React from "react";
import Dropdown from "./Dropdown";
import Searchbar from "./Searchbar";
import Button from "./Button";
import Container from "./Container";
import Table1 from "./Table1";
import { useState, useEffect } from "react";
import { useReducer } from 'react';
import ViewClaim from "./ViewClaim";
import { reducer, initialState } from '../reducers/reducers';
import NewClaimTicket from "./NewClaimTicket";
import API_URLS from "../Urls";
import EditText from "./EditText";
import { useAuth } from "./AuthProvider";

const SearchClaimTicket = ({ onSelected, onDeselected }) => {
  const { canRead, canWrite } = useAuth();
  const [state, dispatch] = useReducer(reducer, initialState);
  const [isSelected, setSelected] = useState(false);
  const [note, setNote] = useState(null);
  const [searchOption, setSearchOption] = useState('idNota'); // default to 'id'
  const [searchData, setSearchData] = useState('');
  const [viewData, setViewData] = useState({});
  const [fetchedNotes, setFetchedNotes] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage] = useState(20);
  const [lastPage, setLastPage] = useState(1);
  const [total, setTotal] = useState(0);

  // 🔹 Fetch all notes
  const fetchNotes = (url = API_URLS.CLAIM_TICKETS) => {
    if (!canRead('acceso_notas_recepcion')) {
      alert('No tienes permisos para ver estos datos');
      setFetchedNotes([]);
      setLastPage(1);
      setTotal(0);
      return;
    }

    const paginatedUrl = `${url}?page=${page}&per_page=${perPage}`;
    console.log(`Solicitando datos: ${paginatedUrl}`);

    fetch(paginatedUrl, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
      .then(res => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then(result => {
        if (result?.data && result.page !== undefined) {
          setFetchedNotes(result.data);
          setLastPage(result.last_page);
          setTotal(result.total);
        } else {
          const dataArray = Array.isArray(result) ? result : [];
          const start = (page - 1) * perPage;
          const end = Math.min(start + perPage, dataArray.length);
          setFetchedNotes(dataArray.slice(start, end));
          setLastPage(Math.ceil(dataArray.length / perPage) || 1);
          setTotal(dataArray.length);
        }
      })
      .catch(err => {
        console.error('Fetch error:', err);
        setFetchedNotes([]);
        setLastPage(1);
        setTotal(0);
      });
  };

  // 🔹 Search notes
  const searchNotes = () => {
    if (!canRead('acceso_notas_recepcion')) {
      alert('No tienes permisos para ver estos datos');
      return;
    }

    var param;
    if(searchOption=='Id'){
        param = 'idNota';
    } else if (searchOption=='IdCliente'){
        param = 'idCliente';
    } else{
        param = 'nombre'
    }
    const url = `${API_URLS.CLAIM_TICKETS}?${param}=${searchData}`;
    console.log(`Buscando: ${url}`);

    fetch(url, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
      .then(res => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.json();
      })
      .then(result => {
         if (result?.data && result.page !== undefined) {
          setFetchedNotes(result.data);
          setLastPage(result.last_page);
          setTotal(result.total);
        } else {
          const dataArray = Array.isArray(result) ? result : [];
          const start = (page - 1) * perPage;
          const end = Math.min(start + perPage, dataArray.length);
          setFetchedNotes(dataArray.slice(start, end));
          setLastPage(Math.ceil(dataArray.length / perPage) || 1);
          setTotal(dataArray.length);
        }
      })
      .catch(err => {
        console.error('Search error:', err);
      });
  };

  // Initial load
  useEffect(() => {
    if (canRead('acceso_notas_recepcion')) fetchNotes();
  }, [page, canRead]);

  // 🔹 Ticket list rendering
  const renderTickets = () => {
    if (!isSelected) {
      return (
        <div>
          <Container>
            <div>Buscar por:</div>
            <Dropdown
              options={['Id', 'IdCliente', 'Nombre']}
              returnSelectedOption={option => setSearchOption(option)}
            />
            <EditText text="Buscar..." onChange={value => setSearchData(value)} />
            <Button
              text="Buscar"
              color="#61BAA5"
              onClick={() => (searchData ? searchNotes() : fetchNotes())}
            />
            <Button
              text="Nueva Nota"
              onClick={() => dispatch({ type: 'openNewClaimTicket' })}
              color="#7AACE3"
            />
            {state.statusNewClaimTicket && (
              <NewClaimTicket
                onAccept={() => {
                  dispatch({ type: 'closeNewClaimTicket' });
                  fetchNotes();
                }}
                onClose={() => dispatch({ type: 'closeNewClaimTicket' })}
              />
            )}
          </Container>

          <Table1
            optview
            optselect
            headers={['Folio', 'Tipo', 'Facturar?', 'Cliente', 'Fecha', 'Observaciones', 'Cotizado?', 'Sucursal', 'Causa', '']}
            data={fetchedNotes}
            onClickView={data => {
              setViewData(data);
              dispatch({ type: 'openViewClaim' });
            }}
            onClickSelect={data => {
              onSelected(data);
              setNote(data);
              setSelected(true);
            }}
          />
          <PaginationControls />

          {state.statusViewClaim && (
            <ViewClaim
              data={viewData}
              onClose={() => dispatch({ type: 'closeViewClaim' })}
            />
          )}
        </div>
      );
    }

    return (
      <div>
        <Table1
          optdeselect
          onClickDeselect={() => {
            onDeselected();
            setSelected(false);
            setNote(null);
          }}
          headers={['Folio', 'Tipo', 'Facturar?', 'Cliente', 'Fecha', 'Observaciones', 'Cotizado?', 'Sucursal', 'Causa', 'Reparado antes?']}
          data={[note]}
        />
      </div>
    );
  };

  // Pagination component
  function PaginationControls() {
    const baseStyle = {
      backgroundColor: '#7AACE3',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      padding: '8px 16px',
      margin: '0 5px',
      cursor: 'pointer',
      fontWeight: 'bold',
      transition: 'background-color 0.3s'
    };
    const disabled = { ...baseStyle, backgroundColor: '#ccc', cursor: 'not-allowed', opacity: 0.7 };

    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '15px 0' }}>
        <button onClick={() => setPage(p => Math.max(p - 1, 1))} disabled={page === 1} style={page === 1 ? disabled : baseStyle}>
          &lt; Anterior
        </button>
        <span style={{ margin: '0 15px', fontWeight: 'bold' }}>
          Página {page} de {lastPage} ({total} registros)
        </span>
        <button onClick={() => setPage(p => Math.min(p + 1, lastPage))} disabled={page === lastPage} style={page === lastPage ? disabled : baseStyle}>
          Siguiente &gt;
        </button>
      </div>
    );
  }

  return <div>{renderTickets()}</div>;
};

export default SearchClaimTicket;
